import type { RealtimeStatus } from "@a2z/realtime";
import { retryRealtimeConnection } from "@a2z/realtime/firebase";
import { useTranslations } from "@/lib/i18n/intl";
import { keys } from "@/lib/i18n/portal";
import { Button } from "@/shared/rd";

export function RealtimeNotice({ status, onRetry }: { status: RealtimeStatus; onRetry?: () => void }) {
  const t = useTranslations();
  if (status !== "degraded" && status !== "unconfigured") return null;
  return <div role="status" className="rd-root rd-realtime-notice">
    {/* "unconfigured" is permanent for this build; "degraded" is an interruption. */}
    <span>{t(status === "unconfigured" ? keys.common.realtimeUnconfigured : keys.common.realtimeDegraded)}</span>
    <Button size="sm" onClick={() => { onRetry?.(); retryRealtimeConnection(); }}>{t(keys.common.realtimeRetry)}</Button>
  </div>;
}
